module.exports = __webpack_public_path__ + "assets/icon-prom-selected.9677bc1d.svg";